var indexOf = require('../array/virtual/index-of');

var ArrayPrototype = Array.prototype;

module.exports = function (it) {
  var own = it.indexOf;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.indexOf) ? indexOf : own;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/es/instance/index-of.js
// module id = 439
// module chunks = 0